export default __webpack_public_path__ + "static/media/RoofingBackGround.69545c35.jpg";